import * as React from 'react';
import * as ReactTimeout from 'react-timeout'
import { FitBitIcon } from 'components/widgets/icons';
import { UIState } from 'data/UIState';
import { TrackersData } from 'data/TrackersData';
import { observable } from 'mobx';
import { observer } from 'mobx-react';

import './FitbitBanner.pcss';
import UserDataSource from "data/UserDataSource";
import {Alert} from "../../../data/Alert";
import {handleSpacePressed} from "utils";

@observer
class _FitbitBanner extends React.Component<{setTimeout?:(func:VoidFunction, ms:number)=>void}> {

  @observable disconnecting:boolean = false; 
  @observable startDisconnect:number = 0; 

  handleDisconnectFitbit = () => {
    this.disconnecting = true;
    const startDisconnect = (new Date).getTime();
    TrackersData.disconnectFitbit()
    .then(()=>{      
    })
    .catch(()=>{
      Alert.alert("Failed to disconnect Fitbit. Please try again. This may have happed due to a temporary Internet interruption.");
    })
    .then(()=>{
      const elapsed = ((new Date).getTime()-startDisconnect);
      if(elapsed<1500 && this.props.setTimeout) {
        this.props.setTimeout(()=>{
          this.disconnecting = false;
        }, 1500-elapsed)
      } else {
        this.disconnecting = false;
      }
    });
  } 

  render() {
    if(UIState.user.fitbitEnabled || this.disconnecting) {
      return (
        <div className="fitbitBanner">
          <FitBitIcon color="#02b0b9" />
          <div className="status">
            <h3>Fitbit account connected</h3>
          </div>
          <div className="action"> 
            { this.disconnecting ?
              <span className="disconnecting"><i className="material-icons icon-spin">sync</i> Disconnecting</span> 
            :
              <a
                href="#"
                className="dis"
                onClick={this.handleDisconnectFitbit}
                onKeyDown={(e)=>{ handleSpacePressed(e, this.handleDisconnectFitbit);}}
              ><i className="material-icons">sync_disabled</i> Disconnect Fitbit</a>
            }
          </div>
        </div>
      );
    } else {
      return (
        <div className="fitbitBanner">
          <FitBitIcon color="#666666" />
          <div className="status">
            <h3>No Fitbit connected</h3>
          </div>
          <div className="action"> 
            <a className="con" href={UIState.settings.FITBIT_AUTH_URL}>Setup Fitbit <i className="material-icons">arrow_right_alt</i></a>
          </div>
        </div>
      );
    }
  }
}

export const FitbitBanner = ReactTimeout(_FitbitBanner);
